import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormLabel,
} from '@material-ui/core'
import React from 'react'
import { mainTheme } from '../../utils/mainTheme'
import { useNotify, useRefresh } from 'react-admin'
import { useState } from 'react'
import { apiUrl } from '../AppDataProvider'
import httpClient from '../CustomHttpClient'

const CustomPayoutSettlementPopup = (props: { payoutIdList: string[] }) => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const refresh = useRefresh()
  const notify = useNotify()

  const AddCustomPayoutSettlement = async () => {
    setLoading(true)
    const url = `${apiUrl}/payout-settlement/custom`
    httpClient(url, {
      method: 'post',
      body: JSON.stringify({
        payoutIdList: props.payoutIdList,
      }),
    })
      .then(() => {
        notify('Liquidação personalizada gerada com sucesso')
        setOpen(false)
        refresh()
      })
      .catch((error) => {
        console.error(error)
        notify(`Erro ao gerar liquidação personalizada: ${error}`, 'error')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div>
      <Button
        size="medium"
        color="primary"
        variant="contained"
        onClick={() => setOpen(true)}
      >
        Gerar liquidação personalizada
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent
          style={{
            paddingTop: mainTheme.spacing(3),
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography variant="h2">Gerar liquidação personalizada</Typography>
          <div
            style={{
              marginTop: mainTheme.spacing(2),
            }}
          >
            <FormLabel>
              Tem certeza que deseja gerar uma liquidação personalizada?
            </FormLabel>
            <div>
              <FormLabel>Essa ação não poderá ser revertida.</FormLabel>
            </div>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            paddingTop: mainTheme.spacing(2),
            padding: mainTheme.spacing(3),
          }}
        >
          <Button onClick={() => setOpen(false)} variant="outlined">
            Retornar
          </Button>
          <Button
            onClick={() => {
              AddCustomPayoutSettlement()
            }}
            style={{ marginLeft: 'auto' }}
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            data-testid={'button-cancel-order-submit'}
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CustomPayoutSettlementPopup
